<template>
  <el-form
    ref="form"
    v-loading="isSaving"
    :rules="rules"
    :model="formData"
  >
    <h2>
      Detail
    </h2>
    <el-row :gutter="15">
      <el-col :span="12">
        <el-form-item
          label="Carrier is Enabled"
        >
          <br>
          <el-switch
            v-model="formData.enabled"
            active-text="Yes"
            inactive-text="No"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Freshdesk ID"
        >
          <br>
          <el-input v-model="formData.freshdesk_object_id" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="12">
        <el-form-item
          label="Name"
          prop="name"
        >
          <el-input
            v-model="formData.name"
            placeholder="Carrier Name"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Full Name"
          prop="fullName"
        >
          <el-input
            v-model="formData.fullName"
            placeholder="Full Name"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form-item
          label="Phone"
        >
          <el-input
            v-model="formData.phone"
            placeholder="Phone"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form-item
          label="Address"
          prop="address"
        >
          <el-input
            v-model="formData.address"
            placeholder="Address"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="10">
        <el-form-item
          label="Suburb"
          prop="suburb"
        >
          <el-select
            v-model="formData.suburb"
            clearable
            filterable
            remote
            :remote-method="suburbQuerySearch"
            :loading="isLoading"
            :trigger-on-focus="false"
            class="w-100"
            placeholder="Enter name of suburb"
            value-key="id"
            @change="handleSelectSuburb"
          >
            <el-option
              v-for="item in locations"
              :key="item.id"
              :label="formatSuburbByLocation(item)"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="7">
        <el-form-item
          label="State"
          prop="state"
        >
          <el-input
            v-model="formData.state"
            placeholder="State"
          />
        </el-form-item>
      </el-col>
      <el-col :span="7">
        <el-form-item
          label="Postcode"
          prop="postcode"
        >
          <el-input
            v-model="formData.postcode"
            placeholder="Post Code"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="12">
        <el-form-item
          label="Tier"
          prop="carrier_tier"
        >
          <el-select
            v-model="formData.carrier_tier"
            clearable
            filterable
            class="w-100"
            placeholder="Select Carrier Tier"
          >
            <el-option
              v-for="item in [1, 2, 3, 4, 5, 6]"
              :key="item"
              :label="`Tier ${item}`"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Group"
          prop="carrier_group"
        >
          <el-select
            v-model="formData.carrier_group"
            clearable
            filterable
            remote
            :remote-method="carrierGroupQuerySearch"
            :loading="isLoading"
            :trigger-on-focus="false"
            class="w-100"
            placeholder="Enter name of carrier group"
            value-key="id"
            @change="handleSelectCarrierGroup"
          >
            <el-option
              v-for="item in carrierGroups"
              :key="item.id"
              :label="item.name"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import Filter, { CONTAINS } from '@/plugins/sdk/Filter'

export default {
  props: {
    formData: {
      type: Object,
      default: null,
      required: true
    }
  },
  data () {
    return {
      rules: {
        name: [
          { required: true, message: 'Name is required', trigger: ['blur'] }
        ],
        fullName: [
          { required: true, message: 'Full Name is required', trigger: ['blur'] }
        ],
        address: [
          { required: true, message: 'Address is required', trigger: ['blur'] }
        ],
        suburb: [
          { required: true, message: 'Suburb is required', trigger: ['blur'] }
        ],
        state: [
          { required: true, message: 'State is required', trigger: ['blur'] }
        ],
        postcode: [
          { required: true, message: 'Postcode is required', trigger: ['blur'] }
        ]
      },
      isSaving: false,
      locations: [],
      isLoading: false,
      carrierGroups: []
    }
  },
  created () {
    this.carrierGroups = this.$_.get(this.formData, 'carrier_group') ? [this.formData.carrier_group] : []
  },
  methods: {
    carrierGroupQuerySearch (queryString, cb) {
      this.isLoading = true
      this.$sdk.commercial_carriergroup.list(builder => {
        builder.filters = [
          new Filter('name', CONTAINS, queryString)
        ]
        builder.order = { 'name': 'asc' }
      }).then(res => {
        this.carrierGroups = res
        this.isLoading = false
      })
    },
    suburbQuerySearch (queryString, cb) {
      this.isLoading = true
      this.$sdk.dictionary_location.list(builder => {
        builder.filters = { 'dictionary_location_find': queryString }
        builder.order = { 'suburb': 'asc' }
      }).then(res => {
        this.locations = res
        this.isLoading = false
      })
    },
    handleSelectSuburb (item) {
      this.formData.suburb = item.suburb
      this.formData.state = item.state
      this.formData.postcode = item.postcode
    },
    handleSelectCarrierGroup (item) {
      this.formData.carrier_group_id = item.id
    },
    formatSuburbByLocation (location) {
      if (location) {
        return `${location.suburb}, ${location.state}, ${location.postcode}`
      } else return ''
    }
  }
}
</script>
